import React from 'react';
import CmsArticleTeaserList from './CmsArticleTeaserList';

interface ICmsArticleTeaserListByYear {
    year: ("all" | "current" | "specific"),
    specificYear?: string,
    language: ("de" | "en")
}

const CmsArticleTeaserListByYear : React.FC<ICmsArticleTeaserListByYear> = ({year, specificYear, language}) => {
    const yearMap = [] as {startDate: string, endDate: string, headline: string, skipFirst?: boolean}[];
    if(year === 'all') {
        const currentYear = new Date().getFullYear();
        for(let i = currentYear; i >= 2024; i--) {
            yearMap.push({startDate: `${i}-01-01`, endDate: `${i}-12-31`, headline: `${i}`, skipFirst: false});
        }
    }

    if(year === "current") {
        const currentYear = new Date().getFullYear();
        yearMap.push({startDate: `${currentYear}-01-01`, endDate: `${currentYear}-12-31`, headline: `${currentYear}`, skipFirst: true});
        yearMap.push({startDate: `${currentYear-1}-10-01`, endDate: `${currentYear-1}-12-31`, headline: `${currentYear-1}`, skipFirst: false});
    }

    if(year === "specific" && specificYear) {
        yearMap.push({startDate: `${specificYear}-01-01`, endDate: `${specificYear}-12-31`, headline: `${specificYear}`, skipFirst: false});
    }

    return <>
        {yearMap.map(year => <CmsArticleTeaserList {...year} language={language} />)}
    </>
}

export default CmsArticleTeaserListByYear;